"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lightPalette = void 0;
var _primitives = require("./primitives");
/**
 * Light palette — designed, not mirrored from dark.
 *
 * The historical LightThemeColors reused dark-mode values (dark-navy app
 * background, white borders on white surfaces, slate accent) and was unusable.
 * This palette uses navy-tinted neutrals so light mode still reads as the
 * same product, with every text/surface pair passing WCAG AA (enforced by
 * tokens.test.ts).
 *
 * Elevation note: light mode separates surfaces with soft shadows
 * (see effects.ts); dark mode keeps borders/overlays.
 */
const lightPalette = exports.lightPalette = {
  appBackground: '#F5F7FA',
  background: '#F5F7FA',
  card: '#FFFFFF',
  navigationBar: '#FFFFFF',
  cardStrong: '#E9EEF4',
  section: 'rgba(2, 20, 38, 0.04)',
  modalBackground: '#FFFFFF',
  modalCard: '#F8FAFC',
  // Light mode has no translucent-accent legacy: accent is solid from day one.
  accent: _primitives.brand.cyanDeep,
  accentSolid: _primitives.brand.cyanDeep,
  accentSecondary: _primitives.brand.cyanDeeper,
  text: '#0B1623',
  textSecondary: '#46546A',
  textTertiary: '#64748B',
  // Light mode already passes AA on cardStrong; mirror textSecondary.
  textSecondaryOnStrong: '#46546A',
  textOnAccent: '#FFFFFF',
  tabBarActiveTintColor: _primitives.brand.cyanDeeper,
  tabBarInactiveTintColor: '#64748B',
  // Harmonized semantics — warmer, less stock-Tailwind than the old palette.
  error: '#D64541',
  success: '#198F57',
  warning: '#C57A1A',
  disabled: '#94A3B8',
  border: 'rgba(11, 22, 35, 0.12)',
  shadow: 'rgba(11, 22, 35, 0.10)',
  // Cool brand primary for data/icons — NOT the generic blue (which read as
  // stock MUI). CTAs use accentWarm; this drives data/info accents. cyanDeeper
  // (not cyanDeep) so white text on it clears AA (5.5:1) for secondary buttons.
  primary: _primitives.brand.cyanDeeper,
  primaryLight: 'rgba(3, 105, 161, 0.08)',
  // Light-specific gradient stops (richer + cool-leaning; dark keeps its own
  // pixel-locked stops). Hues keep their data meaning: session, lap, shared.
  sessionGradientStart: '#7C5CFF',
  sessionGradientEnd: '#22A7E0',
  lapGradientStart: '#10B981',
  lapGradientEnd: '#0E9F9A',
  sharedLapsGradientStart: '#F59E0B',
  statIconPrimary: _primitives.brand.cyanDeeper,
  statIconBlue: '#3B82F6',
  statIconGreen: '#16A34A',
  badgeBackground: '#E2E8F0',
  badgeText: '#475569'
};